import { atom } from "jotai";

import { AccountNotFoundStep } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const ProceedToAccountNotFoundStepAtom = atom(
  null,
  (
    get,
    set,
    { email, phone }: { email: string | null; phone: string | null }
  ) => {
    const track = get(VerificationModalTrackEventAtom);
    const nextStep: AccountNotFoundStep = {
      step: "AccountNotFound",
      backStep: "Initial",
      email,
      phone,
    };
    set(VerificationModalStepStateAtom, nextStep);
    track?.("AuthModal.AccountNotFoundStep", nextStep);
  }
);
